export default {
  downloads: {
    description:
      "Useful software for diagnostic and programming of Brokk machines.",
    itemName: "Software",
    size: "Size",
    subtitle: "Download software for Brokk machines."
  }
}
